<div class="card">
  <div class="card-header card-title">
    <h5 class="m-0 p-0" i18n="@@EnergyDistributionChart">Leistung im Tagesverlauf in kW</h5>
  </div>

  <div id="distribution-chart" class="card-body">
    <div *ngIf="this.isLoading" class="loading-spinner-container" style="margin-top: 80px;">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@GeneratingStatisticsHint">Grafik zum Energiefluss wird generiert</span>
      </div>
    </div>

    <canvas id="distribution-chart-canvas" class="" style="display: block; box-sizing: border-box;"
            [ngStyle]="{'visibility': !isLoading ? 'visible' : 'hidden'}"></canvas>
  </div>
</div>
